import { CompanyMember, CompanyMemberApiListCompanyMembersByMemberIdRequest } from "@vitable/asclepius-api-client-ts"

import useAsclepius from "@common/composables/api/asclepius"
import { Ref, ref, watch } from "vue"

export const useListCompanyMembersByMemberId = () => {
  const { getCompanyMemberApi, callWithResponse, callResult } = useAsclepius()

  const companyMembers: Ref<Array<CompanyMember>> = ref([])

  async function listCompanyMembersByMemberId(request: CompanyMemberApiListCompanyMembersByMemberIdRequest) {
    await callWithResponse(() => getCompanyMemberApi().listCompanyMembersByMemberId(request))
  }

  watch(callResult, (newValue) => {
    // @ts-ignore
    if (newValue.isSuccess()) {
      const data = callResult.value.getData()
      companyMembers.value = data.company_members
    }
  })

  return {
    listCompanyMembersByMemberId,
    listCompanyMembersResult: callResult,
    companyMembers
  }
}
